export const css = {
    root: '_32fujPZn',
    listItem: '_18MPRvlL',
    ' _key': 'afcpe-theme/dojo/breadcrumb-group'
};
export default css;
